import jsPDF from 'jspdf';

const COLUMN_SPACE = 5;
const LINE_SPACE = 5;
const ITEMS_PER_PAGE_PORTRAIT = 50;
const ITEMS_PER_PAGE_LANDSCAPE = 19;
const MAX_COLUMN_WIDTH = 29; //10 columnas

const generatePDF = (objects, headers) => {

    const pages = objects.length / ITEMS_PER_PAGE_PORTRAIT;
    let page = 0;

    let doc = new jsPDF('p', 'mm', 'a4');

    while (page < pages) {

        doc.setFontType('bold');
        doc.setFontSize(16);
        let column = 20;
        let line = 20;
        let columns = [column];
        headers.map(header => {
            doc.text(header, column, line);
            column = column + doc.getTextWidth(header) + COLUMN_SPACE;
            columns.push(column);
        });

        doc.setFontType('normal');
        doc.setFontSize(10);
        line = line + 10;

        objects.slice(page * ITEMS_PER_PAGE_PORTRAIT, page * ITEMS_PER_PAGE_PORTRAIT + ITEMS_PER_PAGE_PORTRAIT).map(object => {
            Object.values(object).map((text, index) => {
                return doc.text(String(text), columns[index], line);
            });

            line = line + LINE_SPACE * 2;

        });

        page++;
        if (page < pages) {
            doc.addPage();
        }
    }
    return doc;
};


const generateTablePDF = (objects, headers) => {

    const pages = objects.length / ITEMS_PER_PAGE_LANDSCAPE;
    let page = 0;

    let doc = new jsPDF('l', 'mm', 'a4');

    while (page < pages) {

        doc.setFontType('bold');
        doc.setFontSize(12);
        let column = 10;
        let line = 10;
        let columns = [column];
        let lineSpaceFactor = 1;

        headers.map((header, idx) => {
            let columnWidth = doc.getTextWidth(header);
            let value = header;
            if (columnWidth > MAX_COLUMN_WIDTH) {
                value = header.split(' ');
                lineSpaceFactor = Math.max(lineSpaceFactor, value.length);
            }

            doc.text(value, column, line);
            column = column + MAX_COLUMN_WIDTH;
            columns.push(column);
        });

        doc.setFontType('normal');
        doc.setFontSize(8);
        line = line + (LINE_SPACE * lineSpaceFactor);
        lineSpaceFactor = 1;

        objects.slice(page * ITEMS_PER_PAGE_LANDSCAPE, page * ITEMS_PER_PAGE_LANDSCAPE + ITEMS_PER_PAGE_LANDSCAPE).map(object => {
            Object.values(object).map((text, index) => {
                let value = String(text).trim();
                let columnWidth = doc.getTextWidth(value);
                if (columnWidth > MAX_COLUMN_WIDTH) {
                    let aux = [];
                    if (index === 9) {
                        const idx = text.indexOf('/');
                        if (idx !== -1) {
                            aux.push(value.substring(0, idx + 1));
                            aux.push(value.substring(idx + 1, 30));
                        } else {
                            aux.push(value.substring(0, 15));
                            aux.push(value.substring(15, 29));
                        }
                    } else {
                        aux.push(value.substring(0, 15));
                        aux.push(value.substring(15, 29));
                    }
                    lineSpaceFactor = Math.max(lineSpaceFactor, 2);
                    return doc.text(aux, columns[index], line);
                }
                else {
                    return doc.text(value, columns[index], line);
                }
            });

            line = line + (LINE_SPACE * lineSpaceFactor);
            lineSpaceFactor = 1;
        });

        page++;
        if (page < pages) {
            doc.addPage();
        }
    }
    return doc;
};

/**
 * Export an PDF document.
 * 
 * @param {Array} data array of objects to save in pdf document
 * @param {Array} headers array of strings to use as headers in PDF document
 * @param {String} fileName 
 */
export const exportToPDF = (data, headers, fileName, asTable = false) => {
    let document;
    if (asTable) {
        document = generateTablePDF(data, headers);
    }
    else {
        document = generatePDF(data, headers);
    }

    document.save(`${fileName}.pdf`);
};


// WEBPACK FOOTER //
// ./src/components/Utils/exportToPDF.js